import { ArrowRight, Loader2, Package, Truck, Warehouse } from "lucide-react";
import type { LucideIcon } from "lucide-react";
import { Link } from "react-router-dom";

import {
  useM1Dashboard,
  useM1LeadTime,
  useM1Spedibili,
  useM1StockEccedente,
} from "@/hooks/useM1";
import { cn } from "@/lib/utils";

export function WidgetKpiDirezionali() {
  const dashboard = useM1Dashboard();
  const lead = useM1LeadTime();
  const spedibili = useM1Spedibili("oggi");
  const stock = useM1StockEccedente();

  // Evadibili = campo calcolato backend (peggior stato Maitime ≠ inevadibile).
  // Fix M4: niente più match per stringa fragile lato frontend.
  const evadibili = dashboard.data?.ordini_evadibili ?? null;

  const palletAttesi = spedibili.data?.n_pallet_totale ?? null;
  const camionStim = spedibili.data?.n_camion_stimato ?? null;

  const ltMediana = lead.data?.lt_mediana_giorni;

  const stockEccedente = stock.data?.length ?? null;

  return (
    <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
      <KpiBox
        icon={Package}
        label="Commesse evadibili"
        valore={evadibili ?? "—"}
        hint={dashboard.data ? `${dashboard.data.ordini_aperti} aperte tot` : ""}
        loading={dashboard.isLoading}
        linkTo="/moduli/order-readiness"
      />
      <KpiBox
        icon={Truck}
        label="Pallet attesi (oggi)"
        valore={palletAttesi ?? "—"}
        hint={camionStim !== null ? `≈ ${camionStim} camion` : ""}
        loading={spedibili.isLoading}
        linkTo="/moduli/spedizioni"
      />
      <KpiBox
        icon={Package}
        label="Lead time mediano"
        valore={ltMediana !== null && ltMediana !== undefined ? `${ltMediana}g` : "—"}
        hint="target contrattuale ≤ 21g"
        loading={lead.isLoading}
        toneByLt={ltMediana}
        linkTo="/moduli/order-readiness"
      />
      <KpiBox
        icon={Warehouse}
        label="Articoli stock eccedente"
        valore={stockEccedente ?? "—"}
        hint="ridurre capitale fermo"
        loading={stock.isLoading}
        linkTo="/moduli/order-readiness?tab=segnali"
      />
    </div>
  );
}

function KpiBox({
  icon: Icon,
  label,
  valore,
  hint,
  loading,
  toneByLt,
  linkTo,
}: {
  icon: LucideIcon;
  label: string;
  valore: string | number;
  hint?: string;
  loading?: boolean;
  toneByLt?: number | null;
  linkTo: string;
}) {
  const tone =
    toneByLt === null || toneByLt === undefined
      ? ""
      : toneByLt > 35
        ? "text-red-600 dark:text-red-400"
        : toneByLt > 21
          ? "text-amber-600 dark:text-amber-400"
          : "text-emerald-600 dark:text-emerald-400";

  return (
    <Link
      to={linkTo}
      className="group rounded-lg border bg-card/40 p-3 hover:bg-card transition-colors block"
    >
      <div className="flex items-center justify-between">
        <Icon className="size-4 text-muted-foreground" />
        <ArrowRight className="size-3.5 text-muted-foreground opacity-0 group-hover:opacity-100 transition-opacity" />
      </div>
      {loading ? (
        <Loader2 className="size-4 animate-spin text-muted-foreground mt-1" />
      ) : (
        <p className={cn("text-2xl font-semibold tabular-nums mt-1", tone)}>
          {valore}
        </p>
      )}
      <p className="text-xs text-muted-foreground">{label}</p>
      {hint && <p className="text-[10px] text-muted-foreground/70 mt-0.5">{hint}</p>}
    </Link>
  );
}
